/**
 * Tiny presence dot with color per status. Use as a positioned absolute
 * child of an avatar wrapper. `size` is the diameter in px.
 */
import { usePresence } from "@/lib/PresenceContext";

const COLORS = {
  online: "bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.7)]",
  lft: "bg-neon shadow-[0_0_8px_rgba(0,229,255,0.7)]",
  away: "bg-amber-400 shadow-[0_0_6px_rgba(251,191,36,0.6)]",
  offline: "bg-zinc-600",
};

export default function PresenceDot({ userId, size = 12, className = "", forceStatus = null, testId }) {
  const { statusOf, isOnline } = usePresence();
  const status = forceStatus
    ? forceStatus
    : (isOnline(userId) ? (statusOf(userId) || "online") : "offline");
  const cls = COLORS[status] || COLORS.offline;
  return (
    <span
      data-testid={testId}
      className={`inline-block rounded-full border-2 border-zinc-950 ${cls} ${className}`}
      style={{ width: size, height: size }}
      title={status}
    />
  );
}
